module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('AppHeading', {
    attrs: {
      "level": "2",
      "mod": "bold, uppercase"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _c('ListPageLayout', {
    attrs: {
      "mod": "bottom"
    }
  }, [_vm._t("default"), (_vm.component) ? _vm._l((_vm.list), function(item, index) {
    return _c(_vm.component, _vm._b({
      key: index,
      tag: "component"
    }, 'component', item, false))
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f8e9e2c","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppCardsList/AppCardsList.vue
// module id = 9758a867dac984789b11
// module chunks = 89